import type {CreateSupplierFormPayload} from "./create-supplier.schema";

import {createSupplier} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {supplierKeys, supplierMutationKeys} from "../../../supplier-keys";

import {createSupplierMapper} from "./create-supplier.mapper";

export function createSupplierMutationOptions() {
  return mutationOptions({
    mutationKey: supplierMutationKeys.createSupplier,
    mutationFn: (payload: CreateSupplierFormPayload) =>
      createSupplier(createSupplierMapper.toSdk(payload)),
    onSuccess: async (_id, _payload, _context, {client}) => {
      await client.invalidateQueries({queryKey: supplierKeys.lists()});
    },
  });
}
